import React, { createContext, useContext, useState, useEffect } from 'react';
import toast from 'react-hot-toast';

const WishlistContext = createContext(null);
const STORAGE_KEY = 'mbx_wishlist_v2';

export const WishlistProvider = ({ children }) => {
  const [wishlistItems, setWishlistItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(wishlistItems));
  }, [wishlistItems]);

  const toggleWishlist = (productId, product) => {
    const id = String(productId);
    setWishlistItems(prev => {
      const exists = prev.some(item => String(item._id || item.id) === id);
      if (exists) {
        toast.success('Removed from wishlist');
        return prev.filter(item => String(item._id || item.id) !== id);
      } else {
        toast.success('Saved to wishlist ❤️');
        // Store product object if provided, else store minimal stub
        const toStore = product ? { ...product, _id: String(product._id || product.id) } : { _id: id };
        return [...prev, toStore];
      }
    });
  };

  const isWishlisted = (productId) => {
    const id = String(productId);
    return wishlistItems.some(item => String(item._id || item.id) === id);
  };

  // Legacy: just IDs array for backward compat
  const wishlist = wishlistItems.map(item => String(item._id || item.id));

  return (
    <WishlistContext.Provider value={{ wishlist, wishlistItems, toggleWishlist, isWishlisted }}>
      {children}
    </WishlistContext.Provider>
  );
};

export const useWishlist = () => useContext(WishlistContext);
